import api from 'utils/api'
export const sendEmail = async (payload: any) => await api.post('/cps/v1/email', payload)
